export const PROGRAM_ENROLLMENTS_WITHOUT_PAYEE_CODE = 'without-payee-code';
export const PROGRAM_ENROLLMENTS_POPULATE_PAYEE_CODE = 'populate-payee-code';

export const PAYEE_CODE_MAX_LENGTH = 15;
export const NAME_MAX_LENGTH = 100;
export const EMAIL_SUBJECT_MAX_LENGTH = 100;
export const EMAIL_CONTENT_MAX_LENGTH = 10000;
export const MAX_AMOUNT = 1000000;
